import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Search } from 'lucide-react';
import { FilterOption } from '../../utils/types';
import SourceCombobox from '../common/SourceCombobox';

interface TicketFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedCategory: string;
  onCategoryChange: (value: string) => void;
  selectedPriority: string;
  onPriorityChange: (value: string) => void;
  categories: FilterOption[];
  priorities: FilterOption[];
}

const TicketFilters = ({
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedPriority,
  onPriorityChange,
  categories,
  priorities,
}: TicketFiltersProps) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    ...categories.filter(option => option.value !== 'all'),
  ];
  const priorityOptions = [
    { value: 'all', label: 'All Priorities' },
    ...priorities.filter(option => option.value !== 'all'),
  ];
  const selectedCategoryLabel =
    categoryOptions.find(option => option.value === selectedCategory)?.label ||
    '';
  const selectedPriorityLabel =
    priorityOptions.find(option => option.value === selectedPriority)?.label ||
    '';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Filter Tickets</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label htmlFor="search">Search</Label>
            <div className="relative">
              <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
              <Input
                id="search"
                type="text"
                placeholder="Search tickets..."
                value={searchTerm}
                onChange={e => onSearchChange(e.target.value)}
                className="pl-10"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="category">Category</Label>
            <SourceCombobox
              id="category"
              items={categoryOptions.map(option => option.label)}
              placeholder="Select category"
              value={selectedCategoryLabel}
              onChange={value => {
                const option = categoryOptions.find(
                  item => item.label === value
                );
                if (option) {
                  onCategoryChange(option.value);
                }
              }}
              emptyText="No categories found."
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="priority">Priority</Label>
            <SourceCombobox
              id="priority"
              items={priorityOptions.map(option => option.label)}
              placeholder="Select priority"
              value={selectedPriorityLabel}
              onChange={value => {
                const option = priorityOptions.find(
                  item => item.label === value
                );
                if (option) {
                  onPriorityChange(option.value);
                }
              }}
              emptyText="No priorities found."
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TicketFilters;
